import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Button, Modal, Col, Glyphicon, Row} from "react-bootstrap"

class ConfirmModal extends Component {

	render() {
		const {message, title, button, onConfirm, onCancel, isShowing} = this.props
		if (!isShowing) {
			return null
		}

		return <Modal onHide={onCancel} show={true}>
			<Modal.Header>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p>{message}</p>
			</Modal.Body>

			<Modal.Footer>
				<Row>
					<Col sm={12}>
						<Button onClick={onCancel}>Storno</Button>
						<Button onClick={() => onConfirm().then(onCancel())} type="submit" bsStyle={button && button.style ? button.style : "warning"}>
							<Glyphicon glyph={button && button.icon ? button.icon : "ok"}/> {button && button.label ? button.label : "OK"}</Button>
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	}
}

ConfirmModal.propTypes = {
	message: PropTypes.string,
	title: PropTypes.string,
	button: PropTypes.object,
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	isShowing: PropTypes.bool.isRequired,
}

export default ConfirmModal


// WEBPACK FOOTER //
// ./src/components/ConfirmModal.js